import { useEventListener } from "@vueuse/core";
import { CROSS_MEETING_SUMMARY_REGENERATED_EVENT, OPEN_HELPDESK_ARTICLE_EVENT, OPEN_HELPDESK_CONVERSATION_EVENT, OPEN_QNA_EVENT, TOGGLE_INTERCOM_EVENT, TRANSCRIPT_EDITED_EVENT, TRANSCRIPT_HIGHLIGHTS_EVENT } from "@/common/helpers/custom-events";
export const useStudyObjectiveChanged = (handler) => {
    useEventListener(window, "studyObjectiveUpdated", (evt) => {
        handler(evt.detail == true);
    });
};
export const useOpenQnAListener = (handler) => {
    useEventListener(window, OPEN_QNA_EVENT, (evt) => {
        handler(evt.detail);
    });
};
export const useOpenHelpdeskArticleListener = (handler) => {
    useEventListener(window, OPEN_HELPDESK_ARTICLE_EVENT, (evt) => {
        handler(evt.detail);
    });
};
export const useOpenHelpdeskConversationListener = (handler) => {
    useEventListener(window, OPEN_HELPDESK_CONVERSATION_EVENT, (evt) => {
        handler(evt.detail);
    });
};
export const useToggleIntercomListener = (handler) => {
    useEventListener(window, TOGGLE_INTERCOM_EVENT, handler);
};
export const useCrossMeetingSummaryRegeneratedListener = (handler) => {
    useEventListener(window, CROSS_MEETING_SUMMARY_REGENERATED_EVENT, (evt) => {
        handler(evt.detail);
    });
};
export const useTranscriptEditedListener = (handler) => {
    useEventListener(window, TRANSCRIPT_EDITED_EVENT, (evt) => {
        handler(evt.detail);
    });
};
export const useTranscriptHighlightsListener = (handler) => {
    useEventListener(document, TRANSCRIPT_HIGHLIGHTS_EVENT, (evt) => {
        handler(evt.detail);
    });
};
